import {WrapperDiv, TextStyles, ImgStyles} from './UserAvatar.styles';

const UserAvatar = ({userImg = '', firstName = '', lastName = '', size = ''}) => {
  return (
    <WrapperDiv size={size}>
      {userImg ? (
        <ImgStyles src={userImg} size={size} />
      ) : (
        <TextStyles size={size}>
          {firstName && firstName.charAt(0)}
          {lastName && lastName.charAt(0)}
        </TextStyles>
      )}
    </WrapperDiv>
  );
};

export default UserAvatar;
